import {
    RESET_EMAIL_OPEN_MODAL,
    RESET_EMAIL_CLOSE_MODAL,
    RESET_EMAIL_REQUEST,
    RESET_EMAIL_RESULT,
} from 'Redux/actionTypes';

export const resetEmailOpenModal = (data) => ({
    type: RESET_EMAIL_OPEN_MODAL,
    payload: data
})

export const resetEmailCloseModal = () => ({
    type: RESET_EMAIL_CLOSE_MODAL
})

export const resetEmailRequest = (data) => ({
    type: RESET_EMAIL_REQUEST,
    payload: data
})

export const resetEmailResult = (result) => ({
    type: RESET_EMAIL_RESULT,
    payload: result
})